export enum Language {
  Arabic = "ae",
  English = "en",
}

export enum VerificationMethod {
  SMS = "SMS",
  EMAIL = "EMAIL",
  QUESTIONS = "QUESTIONS",
}

export enum ENTITY_FLAGS {
  MUST_BE_PMO = 1,
  MUST_NOT_BE_PMO = 2,
}

export enum CellType {
  text = "text",
  percentage = "percentage",
  percentagePeriod = "percentage_period",
  trend = "trend",
  metric = "metric",
  workflow = "workflow",
  rules = "rules",
  yesNo = "yes_no",
  trueFalse = "true_false",
  propList = "propList",
  checkbox = "checkbox",
  date = "date",
  datetime = "datetime",
  status = "status",
  specialCase = "special_case",
  enabled = "enabled",
  dropdown = "dropdown",
  html = "html",
  actual = "actual",
  trasnlatableText = "translate_text",
  agreementStatus = "agreement_status",
}

export enum Direction {
  LTR = "ltr",
  RTL = "rtl",
}

export enum AdaaBoolean {
  Y = "Y",
  N = "N",
}

export enum ActionsEvents {
  view = "view",
  edit = "edit",
  delete = "delete",
  connections = "connections",
  custom = "custom",
}

export enum FilterType {
  date = "date",
  dateRange = "date_range",
  dropdownSingle = "dropdown_single",
  dropdownMulti = "dropdown_multi",
  dropdownTree = "dropdown_tree",
  textFields = "text",
  ignored = "no_filter",
  valueRange = "value_range",
  YearRange = "year_range",
}

export enum PermissionAction {
  view = "view",
  create = "create",
  manage = "manage",
  execute = "execute",
  dataEntry = "dataEntry",
}

export enum PermissionEntityFlag {
  pmo = 1,
  notPmo = 2,
}

export enum AiKpiClassification {
  MAIN = 106300,
  SUB = 106301,
  METRIC = 106302,
}

export enum ProcedureResponsibilityType {
  HUMAN = 106730,
  AGENT = 106731,
  HUMAN_AND_AGENT = 106732,
}

export enum TrackEntryClassification {
  TRAINING_HOURS = 106750,
  AI_AND_DATA = 106751,
  OPERATIONS = 106752,
  STRATEGIC_TASKS = 106753,
  SERVICES = 106754,
}

export enum PublishedState {
  published = 350,
  notPublished = 351,
}

export enum PageMode {
  view = "view",
  edit = "edit",
  create = "create",
}

export enum AdministrativeTitle {
  minister = 1,
  directorGeneral = 2,
}

export enum FileInputType {
  pdf = ".pdf",
  txt = ".txt",
  doc = ".doc",
  docx = ".docx",
  png = ".png",
  jpg = ".jpg",
  gif = ".gif",
  jpeg = ".jpeg",
  bmp = ".bmp",
  svg = ".svg",
  zip = ".zip",
  xls = ".xls",
  xlsx = ".xlsx",
  ppt = ".ppt",
  pptx = ".pptx",
  csv = ".csv",
}

export enum CalculationDataType {
  ENTITY = "ENTITY",
  GOVERNMENT = "GOVERNMENT",
  GOVERNMENT_PILLARS = "GOVERNMENT_PILLARS",
}

export enum NonSystemTeamMemberType {
  ADAA_ENTITY = 1,
  OTHER_ENTITY = 2,
  PARENT_PROJECT = 3,
}

export enum NtkpiContinuityOptions {
  CONTINUITY = "continuity",
  COMPLETED = "completed",
}

export enum ProjectStatus {
  ALL = 0,
  COMPLETED = "completed",
  ON_TIME = "onTime",
  DELAYED = "delayed",
  MOST_COMPLETED = "mostCompleted",
  MOST_DELAYED = "mostDelayed",
  BEST_VISION = "bestVision",
  LOWEST_VISION = "lowestVision",
  ON_TRACK = "onTrack",
  NEED_IMPROVEMENT = "needImprovement",
  NOT_STARTED = "notStarted",
}

export enum ItemStatusDs3 {
  DELAYED = "DELAYED",
  NEED_IMPROVEMENT = "NEED_IMPROVEMENT",
  ON_TRACK = "ON_TRACK",
  COMPLETED = "COMPLETED",
  NOT_STARTED = "NOT_STARTED",
}

export enum UaePassErrors {
  CANCELLED_ON_WEB = "Cancelled by user on UAE PASS web.",
  CANCELLED_ON_APP = "Cancelled by user on UAE PASS app.",
  USER_CLICKED_ON_EXIT = "User clicks on exit on UAE PASS notification during data sharing.",
}

export enum DimensionsSyncTypes {
  STRUCTURE = 1,
  VALUE = 2,
}

export enum ImportExportStatus {
  SUCCESS = "SUCCESS",
  DONE = "DONE",
  PENDING = "PENDING",
  FAIL = "FAIL",
}

export enum ImportExportStatusValues {
  SUCCESS = 0,
  DONE = 1,
  PENDING = 2,
  FAIL = 3,
}

export enum ImportExportType {
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
}

export enum ImportExportObjectType {
  PLAN = "PLAN",
  KPIDATA = "KPIDATA",
  KPI = "KPI",
}

export enum WFTriggerRuleType {
  FIELD_CHECK = 1,
  VALUE_CHECK = 2,
  FALL_BACK_CHECK = 4,
}

export enum ConnectionItemColor {
  main = "#cccccc",
  default = "#d29f35",
  kpi = "#77c8eb",
  service = "#c921eb",
  activity = "#a83279",
  initiative = "#eb77cc",
  objective = "#076ee3",
  tpMilestone = "#00ff37",
  tpProject = "#ff0000",
  govDierction = "#fc7303",
}

export enum SynchronizationSchedulePageType {
  KHADAMATI = "khadamati",
  DIMENSIONS = "dimensions",
  WORKFLOW_DECISION = "workflow_decision",
  ENTITY_DATA = "entity_data",
  ORG_UNIT = "org_unit",
}

export enum SynchronizationScheduleEndPoints {
  jobs = "jobs",
  workflowJobs = "workflow-jobs",
  orgUnit = "fahr-org-unit-sync",
  libmetricStructureScheduler = "libmetric-structure-scheduler",
  libmetricValueScheduler = "libmetric-value-scheduler",
  entityData = "entity-data-sync",
}

export enum CountryValuesTypes {
  TEXT = 104310,
  NUMBER = 104311,
  DATE = 104312,
  DATE_RANGE = 104313,
  LIST_PER_DATE = 104314,
  KEY_VALUE = 104315,
  DATE_RANGE_VALUE = 104316,
}

export enum AttachmentTypes {
  BENCHMARK = 1,
  REPORT = 2,
  EVIDENCE = 3,
  OTHER = 4,
  DATA_SOURCE = 5,
  BASELINE_FILE = 102615,
  ACHIEVEMENT = 104407,
  AGREEMENT = 102642,
  MOU = 104404,
}

export enum DataRevisionIds {
  DS1 = 1,
  DS2 = 2,
  DS3 = 3,
}

export enum KPIsBenchmarks {
  Local = 114,
  International = 115,
  MiddleEastAndNorthAfrica = 116,
  ArabCountries = 117,
  GCC = 118,
  AggregateCountries = 119,
  Universities = 120,
  Other = 121,
  InternationalOrganizations = 122,
  GCC2 = 123,
  ReginalCountries = 246,
}

export enum GovTaskTypes {
  SimpleSponsorTask = 106400,
  TargetSponsorTask = 106401,
  SimpleMultiEntitiesTask = 106402,
  LinkedToAiKpi = 106403,
}

export enum EmployeePulseUploadStatus {
  SUCCESS = "SUCCESS",
  PROCESSING = "PROCESSING",
}
